import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { AgentOptions } from '@newrelic/browser-agent/loaders/agent'

// Remaining import statements

const options = {
  info: {
    applicationID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID,
    beacon: import.meta.env.VITE_NEW_RELIC_BEACON,
    errorBeacon: import.meta.env.VITE_NEW_RELIC_BEACON,
    licenseKey: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY,
    sa: 1,
  },
  init: {
    ajax: {
      deny_list: [
        import.meta.env.VITE_NEW_RELIC_BEACON,
      ],
    },
    browser_consent_mode: {
      enabled: false,
    },
    distributed_tracing: {
      enabled: true,
    },
    performance: {
      capture_detail: false,
      capture_marks: false,
      capture_measures: true,
    },
    privacy: {
      cookies_enabled: true,
    },
    user_actions: {
      enabled: false,
    },
  },
  loader_config: {
    accountID: Number(import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID),
    agentID: Number(import.meta.env.VITE_NEW_RELIC_APPLICATION_ID),
    applicationID: Number(import.meta.env.VITE_NEW_RELIC_APPLICATION_ID),
    licenseKey: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY,
    trustKey: Number(import.meta.env.VITE_NEW_RELIC_TRUST_KEY),
  },
} as AgentOptions

// The agent loader code executes immediately on instantiation.
export const nrba = new BrowserAgent(options)
